import * as React from 'react';

import { PromotionDescription } from '../../../../components/PromotionDescription';
import { useOfferContext } from '../../../../context';
import { useAuctionContext } from '../../../../context/AuctionContext';
import { useApplicationContext } from 'shared/utils/applicationContext';
import { isNotSearcher } from 'shared/utils/isNotSearcher';

export const PromotionDescriptionContainer = () => {
  const { config } = useApplicationContext();
  const { offer, vasList, user } = useOfferContext();
  const { currentBet, liquidityPoints } = useAuctionContext();
  const promotionDescription = offer?.promotion?.promotionDescription;
  const isPerformanceVasPilot = !!offer?.promotion?.isPerformanceVasPilot;
  const isBet = !!(currentBet && !liquidityPoints);

  const isPerformanceVasFlag = !!config.get<boolean>('isPerformanceVASPilot.Enabled');

  if (!isNotSearcher(user) || !promotionDescription || !isPerformanceVasFlag) {
    return null;
  }

  return (
    <PromotionDescription
      promotionDescription={promotionDescription}
      isPerformanceVasPilot={isPerformanceVasPilot}
      item={vasList}
      isBet={isBet}
    />
  );
};
